export interface PaymentMessage {
    allowTenants?: string[];
    allowPlatforms?: string[];
    header?: string;
    body: string;
}
